// Module
var code = "<div class=\"js-collapse-link\" style=\"{{>position}}\"\r\n\ton-mouseover=\"mouseOver\"\r\n\ton-mouseleave=\"mouseLeave\"\r\n\ton-click=\"click\">\r\n\t<div class=\"js-text\" style=\"color:{{.color}}\">{{.text}}</div>\r\n\t<div class=\"js-image\" style=\"background-image:url({{.image}})\"></div>\r\n</div>";
// Exports
export default code;